<template>
    <BasePage :loading="loading" :error="error" :params="params" style="overflow: hidden">
        <SotHeader label="Купить подписку" />
        <div class="q-pa-md base-page-content" style="padding-top: 50px">
            <div class="q-gutter-y-lg" style="margin-bottom: 0" v-show="!loading">
                <div>
                    <div>Название подписки</div>
                    <div class="text-weight-bold ellipsis-3-lines">{{ title }}</div>
                </div>
                <div class="text-weight-bold">
                    Тариф
                    <span v-show="+params.tariff.duration_months > 0">{{ formatMonths(params.tariff.duration_months) }}</span>&nbsp;
                    <span v-show="+params.tariff.duration_days > 0">{{ formatDays(params.tariff.duration_days) }}</span>
                </div>
                <div>
                    <div>К оплате</div>
                    <div class="text-weight-bold">{{ price }} ₽</div>
                </div>
                <div>
                    <div>Ваш баланс:</div>
                    <div class="text-weight-bold">{{ balance }} ₽</div>
                </div>
                <div>Выберите способ оплаты</div>
                <div class="q-gutter-sm">
                    <DefaultButton label="Личный счет в Клубе СОТ" :disabled="balance < price" @click="payFromBalance" :loading="saving" />
                    <DefaultButton label="Банковская карта" @click="payFromCard" />
                </div>
            </div>
        </div>
    </BasePage>
</template>

<script>
import BasePage from 'pages/BasePage';
import SotHeader from 'components/ui/design/SotHeader';
import DefaultButton from 'components/ui/common/DefaultButton';
import filtersMixin from 'src/mixins/filtersMixin';

const moment = require('moment');

export default {
    name: 'PageBuySubscription',
    components: { DefaultButton, SotHeader, BasePage },
    mixins: [filtersMixin],
    props: {
        params: {
            type: Object,
            default: undefined,
        },
    },
    data () {
        return {
            loading: false,
            saving: false,
            error: undefined,
            price: 0,
            discount: 0,
            balance: 0,
        };
    },
    computed: {
        subscriptionId () {
            if (!this.params.subscription) {
                return undefined;
            }
            return this.params.subscription.id;
        },
        title () {
            if (!this.params.subscription) {
                return undefined;
            }
            return this.params.subscription.title;
        },
    },
    mounted () {
        this.load();
    },
    methods: {
        load () {
            this.price = this.params.tariff.price_personal;
            this.loading = true;
            this.$db.users.getMyBalance().then((balance) => {
                this.balance = balance.replaceAll('.00', '');
                this.loading = false;
            });
        },
        payFromBalance () {
            this.$q.dialog({
                title: 'Подтверждение',
                message: `Вы хотите оформить подписку и оплатить с баланса Вашего личного счета в Клубе СОТ? <br/><br/>Будет списана сумма: <b>${this.price} ₽</b>`,
                html: true,
                persistent: true,
                ok: {
                    label: 'Оплатить',
                    color: 'primary',
                },
                cancel: {
                    label: 'Отмена',
                    flat: true,
                },
            }).onOk(() => {
                const m = +this.params.tariff.duration_months;
                const d = +this.params.tariff.duration_days;
                const validUntilDate = moment().add(m, 'month').add(d, 'day');
                this.saving = true;
                this.$db.users.buySubscription(this.price, this.subscriptionId, validUntilDate, this.title).then((result) => {
                    this.saving = false;
                    if (result) {
                        const hint = 'Поздравляем! Подписка оформлена успешно.';
                        this.$pages.push({
                            to: 'buy-success', title: this.title, product_type: 2, product_id: this.subscriptionId, hint,
                        });
                    }
                });
            });
        },
        payFromCard () {
            this.$q.notify('TODO: Перейти на страницу оплаты картой');
        },
    },
};
</script>

<style scoped>

</style>
